<template>
    <!-- Główny kontener, zawierający sekcję filtrów i formularz -->
    <div class="content">
      <div class="d-flex filters">
        <!-- Przypisujemy dynamiczny key, żeby łatwo resetować cały filtr -->
        <FilterCalibrationComponent />
  
        <form @submit.prevent="saveData" class="mt-3 d-flex align-items-center">
          <label for="calibration-datetime" class="me-2">{{ t('select-date-and-time') }}:</label>
          <input
            id="calibration-datetime"
            type="datetime-local"
            v-model="selectedDateTime"
            required
            class="form-control me-2"
          />
          <button type="submit" class="btn btn-primary">
            {{ t('save-and-log') }}
          </button>
        </form>
      </div>
    </div>
  </template>
  
  <script>
  import moment from "moment";
  import FilterCalibrationComponent from "./FilterCalibrationComponent";
  import CalibrationsService from "@/services/CalibrationsService";
  
  moment.locale("pl");
  
  export default {
    name: "CalibrationAddComponent",
    components: { FilterCalibrationComponent },
    data() {
      return {
        // tu trzymamy wybór daty
        selectedDateTime: ""
      };
    },
    methods: {
      async saveData() {
        if (!this.selectedDateTime) return;
        // console.log("Wybrana data i godzina:", this.selectedDateTime);
  
        // moment.utc czy toISOString? Zależy jak API oczekuje strefy
        const timeISO = moment(this.selectedDateTime).toISOString(true);
  
        try {
          await CalibrationsService.addNewCalibrationTime(timeISO);
          // console.log("Odpowiedź z serwera:", response);
  
          // 1) wyczyść formularz:
          this.selectedDateTime = "";
  
          // 2) zresetuj też cały filtr (przeładowanie komponentu via key)
        //   this.filterKey += 1;
  
        } catch (err) {
          console.error("Błąd podczas zapisu:", err);
          // TODO: obsłuż błąd (np. toast, alert)
        }
      }
    }
  };
  </script>
  
  <style scoped>
  .filters {
    gap: 1rem;
  }
  /* Styl głównego kontenera */
  .content {
    width: 100%;
    min-height: 270px;
    margin-bottom: 20px;
  }
  /* Granice sekcji filtrów */
  .filters {
    border-top: 1px solid var(--border-default);
    border-bottom: 1px solid var(--border-default);
  }
  /* Styl sekcji wyników */
  .results {
    width: 100%;
    padding: 1rem;
    background: var(--surface-secondary);
    border-radius: 4px;
    font-family: monospace;
    font-size: 0.9rem;
  }
  
  /* Kontener przycisków nawigacyjnych */
  .actions {
    background-color: var(--surface-primary);
    min-height: 43px;
  }
  /* Wspólny styl przycisków */
  .actions button {
    border: 0;
    font-size: var(--font-size-xl);
    font-weight: var(--font-weight-bold);
    background: none;
  }
  /* Styl przycisku Zastosuj, z ikonką po prawej */
  .actions .btn-next {
    position: relative;
    padding: 8px 40px 8px 8px;
    color: var(--text-secondary);
  }
  /* Styl przycisku Cofnij */
  .actions .btn-prev {
    margin-left: 30px;
    padding: 0 0 0 40px;
    position: relative;
    color: var(--text-secondary);
  }
  /* Podświetlenie wiersza, gdy dewiacja > 7 */
  .red td {
    background-color: var(--status-error-soft) !important;
  }
  </style>